import { render, staticRenderFns } from "./RegisterReason.vue?vue&type=template&id=166a1c9a&scoped=true&"
import script from "./RegisterReason.vue?vue&type=script&lang=js&"
export * from "./RegisterReason.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReason.vue?vue&type=style&index=0&id=166a1c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a1c9a",
  null
  
)

export default component.exports